<toast-notification #toastNotification></toast-notification>

<div class="acs-toolbar-scroll">
  <div class="acs-toolbar">
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <div class="acs-flex acs-flex--center">
        <i class="fa-solid fa-building acs-dropdown__icon" title="Trade Unit"></i>
        <div class="acs-dropdown" (click)="$event.stopPropagation()">
          <button type="button" class="acs-dropdown__trigger" (click)="toggleLocDropdown()"
                  [class.acs-dropdown__trigger--placeholder]="!locDropdown.selectedValue">
            {{locDropdown.displayText}}
            <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
          </button>
          <div class="acs-dropdown__panel" *ngIf="locDropdown.isOpen()">
            <input class="acs-dropdown__search" type="text" placeholder="Search..."
                   [ngModel]="locDropdown.searchText()" (ngModelChange)="locDropdown.searchText.set($event)"
                   (click)="$event.stopPropagation()" />
            <div class="acs-dropdown__options">
              <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                   (click)="selectLocOption(null)">-- All Trade Units --</div>
              <div *ngFor="let loc of locDropdown.filtered"
                   class="acs-dropdown__option"
                   [class.acs-dropdown__option--selected]="loc.value === locDropdown.selectedValue"
                   (click)="selectLocOption(loc)">{{loc.text}}</div>
              <div *ngIf="locDropdown.filtered.length === 0" class="acs-dropdown__empty">No matches</div>
            </div>
          </div>
        </div>
      </div>
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-search acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input"
               placeholder="Location name..."
               [ngModel]="locationFilter" (ngModelChange)="locationFilter = $event; applyFilters()">
      </div>
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-city acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input"
               placeholder="City..."
               [ngModel]="cityFilter" (ngModelChange)="cityFilter = $event; applyFilters()">
      </div>
      <button type="button" class="acs-action-btn" (click)="loadElevatorLocations()">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <small *ngIf="elevatorLocations.length > 0" class="acs-text-muted">{{elevatorLocations.length}} mapping(s)</small>
      <button type="button" class="acs-action-btn acs-action-btn--danger"
              [disabled]="selectedCount === 0"
              (click)="requestBulkDelete()">
        <i class="fa-solid fa-trash"></i> Delete<span *ngIf="selectedCount > 0"> ({{selectedCount}})</span>
      </button>
      <button type="button" class="acs-action-btn acs-action-btn--accent"
              [disabled]="!locDropdown.selectedValue"
              (click)="addMapping()">
        <i class="fa-solid fa-plus"></i> Add
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!hasSearched" class="acs-table-wrap--connected acs-empty-state-wrap">
    <div class="acs-empty-state">
      <i class="fa-solid fa-link"></i>
      Select a trade unit or search to view mappings
    </div>
  </div>

  <div *ngIf="hasSearched" class="acs-table-wrap acs-table-wrap--connected acs-table--contained">
    <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
      <thead class="acs-thead--primary acs-sticky">
        <tr>
          <th class="acs-table__checkbox-col">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="allVisibleSelected && elevatorLocations.length > 0"
                   (change)="toggleSelectAll()">
          </th>
          <th>Trade Unit</th>
          <th>Elevator Code</th>
          <th>Location</th>
          <th>City</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of elevatorLocations"
            (click)="selectMapping(item)"
            class="acs-cursor-pointer">
          <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="isSelected(item.elevatorLocationId)"
                   (change)="toggleSelect(item.elevatorLocationId, $event)">
          </td>
          <td>{{item.locCode}}</td>
          <td>{{item.elevatorCode}}</td>
          <td>{{item.locationCode}} - {{item.locationName}}</td>
          <td>{{item.city}}</td>
        </tr>
        <tr *ngIf="elevatorLocations.length === 0">
          <td colspan="5" class="acs-text-center acs-text-muted">No mappings found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Modal -->
<div *ngIf="showDialog" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">{{isEditing ? 'Edit' : 'Add'}} Mapping</h6>
        <button type="button" class="acs-btn--close" (click)="closeDialog()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <div class="acs-row acs-mb-2">
          <div class="acs-col--md6">
            <label class="acs-label">Trade Unit</label>
            <select class="acs-select" [(ngModel)]="formLocCode" [disabled]="isEditing">
              <option value="">-- Select --</option>
              <option *ngFor="let loc of locList" [value]="loc.value">{{loc.text}}</option>
            </select>
          </div>
          <div class="acs-col--md6">
            <label class="acs-label">Elevator Code</label>
            <ng-container *ngIf="isEditing; else addElevatorCode">
              <input type="text" class="acs-input" [value]="formElevatorCode" disabled>
            </ng-container>
            <ng-template #addElevatorCode>
              <ng-container *ngIf="ctrmElevators.length > 0; else manualCodeInput">
                <select class="acs-select" [(ngModel)]="formElevatorCode">
                  <option value="">-- Select Elevator --</option>
                  <option *ngFor="let elev of ctrmElevators" [value]="elev.elevatorCode">
                    {{elev.elevatorCode}} — {{elev.description}}
                  </option>
                </select>
              </ng-container>
              <ng-template #manualCodeInput>
                <input type="text" class="acs-input" disabled placeholder="No elevators available">
              </ng-template>
              <small *ngIf="isLoadingCtrm" class="acs-text-muted">Loading elevators...</small>
            </ng-template>
          </div>
        </div>
        <div class="acs-row acs-mb-2">
          <div class="acs-col--12">
            <label class="acs-label">Location</label>
            <div class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger"
                      (click)="toggleLocationDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!formLocationDisplay">
                {{formLocationDisplay || '-- Select Location --'}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('em-modal-location')">
                <input class="acs-dropdown__search" type="text" placeholder="Search by code, name, or city..."
                       [ngModel]="locationSearchText()" (ngModelChange)="locationSearchText.set($event)"
                       (click)="$event.stopPropagation()" (keyup.enter)="searchLocations()" />
                <div class="acs-dropdown__options">
                  <small *ngIf="isSearchingLocations" class="acs-text-muted acs-ms-1">Searching...</small>
                  <div *ngIf="locationResults.length === 0 && !isSearchingLocations" class="acs-dropdown__empty">
                    Type 2+ chars and press Enter
                  </div>
                  <div *ngFor="let loc of locationResults"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="loc.locationId === formLocationId"
                       (click)="selectLocation(loc)">
                    {{loc.locationCode}} - {{loc.locationName}}<span *ngIf="loc.city">, {{loc.city}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="closeDialog()">Cancel</button>
        <button class="acs-btn acs-btn--primary" (click)="saveMapping()"
                [disabled]="!formElevatorCode || !formLocationId">
          {{isEditing ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Confirmation Dialog -->
<div *ngIf="showBulkDeleteConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="cancelBulkDelete()" [disabled]="isBulkDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{selectedCount}}</strong> elevator mapping(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelBulkDelete()" [disabled]="isBulkDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDelete()" [disabled]="isBulkDeleting">
          {{isBulkDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

